import { connect } from 'react-redux';
import DefaultNewValueProps from './NewValueProps';

const mapStateToProps = ({
  system: { currency, isTablet }
}) => ({
  currency,
  isTablet
});

const NewValueProps = connect(mapStateToProps, null)(DefaultNewValueProps);

export { default } from './ValueProps';
export { NewValueProps };



// WEBPACK FOOTER //
// ./src/universal/components/ValueProps/index.js